import { UserInterface } from "./users";

export interface ClientViewModel {
  name: string;
  taxId: string;
  email?: string;
  phoneNumber?: string;
  alternativePhoneNumber?: string;
  ticket?: TicketViewModel;
  address: {
    street: string;
    add: string;
    neighbor: string;
    city: string;
    state: string;
    zipCode: string;
  };
}

export enum ReferenceType {
  USER = "USER",
  MODULE = "MODULE",
  AGENDA = "AGENDA",
  EVENT = "EVENT",
  TICKET = "TICKET",
  QUESTIONNAIRE = "QUESTIONNAIRE",
  ATTACHMENTS = "ATTACHMENTS",
  INITIAL_PROJECT = "INITIAL_PROJECT",
  FINAL_PROJECT = "FINAL_PROJECT",
  PAYMENT = "PAYMENT",
  MEASURING = "MEASURING",
  OTHER = "OTHER",
}

export interface FormattedLog {
  userId: number;
  referenceId: number;
  referenceType: ReferenceType;
  action: String;
  createdAt: Date;
  ticketId: number;
  latitude?: number;
  longitude?: number;
  locationAccuracy?: number;
  locationCapturedAt?: Date;
}

export interface FormattedComment {
  userId: number;
  content: String;
  createdAt: Date;
  ticketId: number;
}

export interface FormattedEvent {
  agendaId: number;
  start: Date;
  end: Date;
  createdAt: Date;
  ticket: TicketViewModel;
}

export interface PartsRequestProduct {
  id: number;
  productId: number;
  product: ProductViewModel;
  partsRequestId: number;
  partsRequest: PartsRequestViewModel;
  partNumber: string;
  reason: string;
  issueImages: AttachmentViewModel[];
}

export interface PartsRequestViewModel {
  id: number;
  name: string;
  fieldReportId: number;
  fieldReport: any;
  PartsRequestProduct: PartsRequestProduct[];
  approved: boolean;
  status: "PENDING_APPROVEMENT";
  emailSentAt?: Date;
  createdAt: Date;
}

export interface TicketViewModel {
  id: number;
  status: number;
  title: string;
  describedStatus: string;
  description: string;
  seller: string;
  clientId: number;
  events: FormattedEvent[];
  history: FormattedLog[];
  comments: FormattedComment[];
  client: ClientViewModel;
  saleId: number;
  products?: ProductViewModel[];
  owner: UserInterface;
  groups: ProductGroupViewModel[];
  PartsRequest: PartsRequestViewModel[];
  externalId?: number;
  totalValue?: number;
  cancellationReason?: string;
  cancellationImages?: AttachmentViewModel[]
  PaymentAdditions?: PaymentAdditionsViewModel[]
  saleProducts: SaleProductViewModel[]
  discountPercentage?: number;
  saleStatus?:  number;
  isFullPromissory?: boolean;
  buildingInProgress?: boolean;
  minhaVisitaClientName?: string | null;
  isUnavailableForAssemble?: boolean;
  assembleUnavailableStatus?: string | null;
  assembleUnavailableReason?: string | null;
}

export interface SaleProductViewModel {
  id: number
  ticketId: number
  stockId: number
  itemId: number
  idGradeItem: number
  saleId: number
  tickets: TicketViewModel
  name: string
  idNCM: number
  qtd: number
  unitValue: number
  totalValue: number
  deliveryValue: number
  coastValue: number
  createdAt:  string
  updatedAt:  string
}

export interface PaymentAdditionsViewModel {
  id: number;
  typeId: number;
  description: string;
  value: number;
  fieldReportId: number;
  createdAt: string;
  updatedAt: string;
  status: PaymentAdditionStatusEnum;
  fieldReport: any;
  type: PaymentAdditionsTypeViewModel;
}

interface PaymentAdditionsTypeViewModel {
  id: number;
  name: string;
  createdAt: string;
  paymentAdditions: PaymentAdditionsViewModel[];
}

export enum PaymentAdditionStatusEnum {
  PENDING_APPROVEMENT,
  APPROVED,
  REJECTED,
}

export interface ProductViewModel {
  id: number;
  description: string;
  type: string;
  questionareId: number;
  ProductGroup: ProductGroupViewModel;
  fieldReportProduct?: FieldReportProductViewModel[];
}

export interface FieldReportProductViewModel {
  id: number;
  value: number;
  quantity: number;
  installationTax?: number;
  fieldReportId: number;
  fieldReport: any;
  productId: number;
  product: ProductViewModel;
  createdAt: string;
  updatedAt: string;
  productAttachment: any;
  ProductGroup: ProductGroupViewModel;
  productGroupId: number;
}

export interface ProductGroupViewModel {
  id: number;
  name: string;
  fieldReportProducts: FieldReportProductViewModel[];
  fieldReportId: number;
  fieldReport: any;
  fieldReportProductAttachment: any[];
}

export interface AttachmentViewModel {
  id: number;
  fileName: string;
  providerId: number;
  url: string;
  mimeType: string;
  originalFileName?: string;
  referenceType?: string;
  referenceId?: string;
  createdAt: Date;
  ticketId?: string;
  fieldReportId?: string;
  fieldReport?: any;
  creatorId?: string;
  savedQuestionnaireId?: string;
  provider?: string;
  sentToTatico?: boolean;
  taticoFatherItemId?: string;
  saleId?: string;
}

export interface FieldReportViewModel {
  id: number;
  type: "ASSEMBLE" | "MEASURING";
  externalId: number | null;
  title: string;
  saleId: number | null;
  ownerId: number | null;
  notes: string | null;
  dueDate: Date | null;
  status: string;
  statusDescription: string | null;
  rejected: boolean;
  ticketId: number | null;
  clientId: number;
  createdAt: Date;
  updatedAt: Date;
  sentToApp: Date | null;
  filledAt: Date | null;
  startAt: Date | null;
  finishedAt: Date | null;
  isUnavailableForAssemble: boolean;
  assembleUnavailableStatus: string | null;
  assembleUnavailableReason: string | null;

  // Relações
  attachments: AttachmentViewModel[];
  Events: any[];
  client: ClientViewModel;
  owner: UserInterface | null;
  history: any[];
  ticket: TicketViewModel | null;
  minhaVisitaClientName?: string | null;
  products: FieldReportProductViewModel[];
  EventsAssemble: any[];
  PaymentAdditions: PaymentAdditionsViewModel[];
  ProductGroups: ProductGroupViewModel[];
  PartsRequest: PartsRequestViewModel[];
  cancellationImages: AttachmentViewModel[];
  cancellationReason: string | null;
  Comment: Comment[];
  idAssistTec: number | null;
  PriceAdjustmentRequest: any[];
}
